import { render, staticRenderFns } from "./ManageDevices.vue?vue&type=template&id=495356b0&scoped=true"
import script from "./ManageDevices.vue?vue&type=script&lang=js"
export * from "./ManageDevices.vue?vue&type=script&lang=js"
import style0 from "./ManageDevices.vue?vue&type=style&index=0&id=495356b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495356b0",
  null
  
)

export default component.exports